<template>

    <div class="route-login">

        <div class="content">
            <div class="content-holder">

                <div class="logos-holder">
                    <div class="logo">
                        <i class="img logo-aveco-color-180"></i>
                    </div>
                </div>

                <h1>Wachtwoord opnieuw instellen</h1>
                <span class="subtitle">Je huidige wachtwoord is verlopen, je moet daarom een nieuw wachtwoord instellen.</span>

                <form @submit.prevent="submit">

                    <cms-input type="password" name="oldPassword" placeholder="Huidig wachtwoord" v-model="oldPassword"
                               v-validate="'required'" data-vv-as="Huidig wachtwoord" :error="error('oldPassword')"></cms-input>

                    <cms-input type="password" name="newPassword" placeholder="Nieuw wachtwoord" v-model="newPassword"
                               v-validate="'required'" data-vv-as="Nieuw wachtwoord" :error="error('newPassword')"></cms-input>

                    <cms-input type="password" name="newPasswordConfirm" placeholder="Nieuw wachtwoord herhalen" v-model="newPasswordConfirm"
                               v-validate="'required'" data-vv-as="Herhaalde wachtwoord" :error="error('newPasswordConfirm')"></cms-input>

                    <cms-button :loading="submitting" @click="submit">Inloggen</cms-button>
                    <input type="submit" style="display: none" />
                </form>

            </div>
        </div>

        <toast-container></toast-container>

    </div>

</template>

<script>

    import Component from 'vue-class-component'
    import Vue from 'global-vue'

    import getUrlParams from '@wittignl/js-core/utils/getUrlParams'
    import validationMixin from '@wittignl/js-core/mixins/validation'

    import getGraphQLError from 'app/utils/getGraphQLError';
    import ApiError from 'app/enums/ApiError';
    import UserPasswordRequestMutations from 'app/mutations/UserPasswordRequestMutations';
    import EmailAccountType from 'app/auth/EmailAccountType';

    @Component({

        name: 'renew-password',
        mixins: [validationMixin]
    })
    export default class RenewPassword extends Vue
    {
        data(){

            return {

                submitted: false,
                submitting: false,

                oldPassword: null,
                newPassword: null,
                newPasswordConfirm: null
            }
        }

        mounted() {

            this.logger = this.$di.logger.child('RenewPassword');
            this.logger.info('Mounted');

            if(!this.email){
                this.$router.replace({ name: 'login' });
            }
        }

        async submit(){

            this.submitted = true;

            const success = await this.$validator.validateAll();
            if (!success) {

                this.$toast.warning('Niet alle velden zijn correct ingevuld');
                return;
            }

            if(this.newPasswordConfirm !== this.newPassword){

                this.$toast.warning('Het herhaalde wachtwoord komt niet overeen');
                return;
            }

            this.submitting = true;

            const urlParams = getUrlParams(window.location.search);
            const app = urlParams.app || 'monitor';
            const path = urlParams.path || null;

            try {

                await UserPasswordRequestMutations.renewPassword({
                    email: this.email,
                    oldPassword: this.oldPassword,
                    newPassword: this.newPassword,
                });

                await this.$auth.login(EmailAccountType.NAME, { username: this.email, password: this.newPassword, application: app });
                this.loading = false;

                this.$toast.success('Je wachtwoord is gewijzigd');
                this.$di.appSwitcher.navigate(app, path);
            }
            catch(e){

                const errorCode = getGraphQLError(e);
                const errorInfo = errorCode ? e.graphQLErrors[0].userInfo : null;

                this.logger.error(`Error renewing password (${errorCode})`, e);

                if(errorCode === ApiError.AUTH_CURRENT_PASSWORD_INVALID){
                    this.$toast.error('Het ingevoerde huidige wachtwoord is onjuist');
                }
                else if (errorCode === ApiError.PASSWORD_SHORT) {
                    this.$toast.error(`Het wachtwoord dient uit minimaal ${errorInfo.minLength} tekens te bestaan`);
                }
                else if (errorCode === ApiError.PASSWORD_WEAK) {
                    this.$toast.error(`Het gekozen wachtwoord is te zwak, gebruik minimaal 1 kleine letter, 1 hoofdletter en 1 cijfer en/of leesteken`);
                }
                else if (errorCode === ApiError.PASSWORD_NOT_UNIQUE) {
                    this.$toast.error(`Het gekozen wachtwoord is recentelijk al gebruikt, verzin een nieuw wachtwoord`);
                }
                else {
                    this.$toast.error('Het wachtwoord kon niet worden opgeslagen');
                }
            }

            this.submitting = false;
        }

        get email(){

            return this.$route.params.email;
        }
    }

</script>
